import { useAppSelector } from '@/redux/hooks'
import { seesEveryGroup } from '@/domain/store-group'

// REVER-only settings are shown to REVER, with a badge, and left out for merchants, whose saves send them back as they were.
export const useSeesReverOnly = () =>
  seesEveryGroup(useAppSelector((s) => s.userApi.getMe.response.user))
